<!-- <template>
  <div>
   <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view></router-view>
  </div>
</template> -->

<template>
  <div id="app">
	<!-- 缓存的页面，缓存$route.meta.keepAlive为true的组件 -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <!-- 不缓存的页面，不缓存$route.meta.keepAlive为false的组件 -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
   </div>
</template>




<script>
// import HelloWorld from './views/index.vue'
export default {
  name: 'app',
  components: {
    // HelloWorld
  }
}
</script>

<style>
	body{
		background: #fff !important;
	}
</style>
